import {
  Avatar,
  Box,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import {
  useContext,
  useRef,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";
import { useSelector } from "react-redux";
import { FinancialProfile } from "../../../components";
import type { RootState } from "../../../store";
import { ArrowLeftIcon, FallbackProfileIcon, FruitionLogo } from "../../icons";
import { LinkKeepUTM } from "../LinkKeepUTM";
import { useStyles } from "./Header.styles";
import { HeaderContext } from "./HeaderProvider";

type Selector = RootState["profile"];

interface Props {
  isOpenMenu: boolean;
  anchorDropdown: boolean;
  setAnchorDropdown: Dispatch<SetStateAction<boolean>>;
  handleClickMenu: () => void;
}

export const Header = ({
  isOpenMenu,
  handleClickMenu,
  anchorDropdown,
  setAnchorDropdown,
}: Props) => {
  const theme = useTheme();
  const mediumDown = useMediaQuery(theme.breakpoints.down("md"));
  const xsDown = useMediaQuery(theme.breakpoints.down("xs"));
  const { isOpenSearch } = useContext(HeaderContext);
  const classes = useStyles();
  const profile = useSelector<RootState, Selector>((state) => state.profile);

  const [anchorNotifications, setAnchorNotifications] = useState(null);
  const dropdownRef = useRef();

  const handleClose = () => {
    setAnchorDropdown(null);
    setAnchorNotifications(null);
  };

  return (
    <div className={classes.header}>
      <Toolbar className={classes.toolbar}>
        <Box className={classes.right}>
          {(!anchorNotifications || !xsDown) && (
            <LinkKeepUTM to="/participant/dashboard">
              <FruitionLogo
                width={mediumDown ? 120 : 178}
                className={clsx(classes.logo, {
                  [classes.hide]: isOpenSearch,
                })}
              />
            </LinkKeepUTM>
          )}
          {anchorNotifications && (
            <Box className={classes.arrowLeft}>
              <ArrowLeftIcon />
            </Box>
          )}

          <div className={classes.actions}>
            <MenuIcon
              data-testid="menu-icon"
              className={clsx(classes.responsiveMenu, {
                [classes.hide]: isOpenSearch,
                [classes.menuIconActive]: isOpenMenu,
              })}
              onClick={handleClickMenu}
            />
            {anchorDropdown && (
              <FinancialProfile
                participantProfile={profile}
                handleClose={handleClose}
              />
            )}
            <Box
              ref={dropdownRef}
              display="flex"
              direction="row"
              className={classes.userDropdown}
              onClick={() => setAnchorDropdown(dropdownRef.current)}
            >
              {profile?.profilePicturePath ? (
                <Avatar
                  className={classes.avatar}
                  alt={profile?.name}
                  src={profile?.profilePicturePath}
                />
              ) : (
                <Avatar className={classes.avatar}>
                  <FallbackProfileIcon />
                </Avatar>
              )}
            </Box>
          </div>
        </Box>
      </Toolbar>
    </div>
  );
};
